import { ReactNode, useState } from "react";
import { animated, useSpring } from "react-spring";
import { useSwipeable } from "react-swipeable";

import Modal from "../Modal/Modal";

import deleteIcon from "./image 11.png";
import styles from "./swipeable2.module.css";

type TaskCardProps = {
  onDelete: () => void;
  children: ReactNode;
};

export const Swipeable2 = ({ children, onDelete }: TaskCardProps) => {
  const [isDeleteVisible, setIsDeleteVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSwipeLeft = () => {
    setIsDeleteVisible(true);
  };

  const handleSwipeRight = () => {
    setIsDeleteVisible(false);
  };

  const handleDelete = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: handleSwipeLeft,
    onSwipedRight: handleSwipeRight,
  });

  const taskCardAnimation = useSpring({
    width: isDeleteVisible ? "calc(100% - 45px)" : "calc(100% - 0px)",
    config: { duration: 200 },
  });

  const deleteButtonAnimation = useSpring({
    width: isDeleteVisible ? "41px" : "0px",
    config: { duration: 200 },
  });

  return (
    <div {...swipeHandlers}>
      <div className={styles["swipeable-container"]}>
        <animated.div
          className={styles["swipeable-card"]}
          style={taskCardAnimation}
        >
          {children}
        </animated.div>
        {isDeleteVisible && (
          <animated.div
            className={styles["delete-button"]}
            style={deleteButtonAnimation}
          >
            <button onClick={handleDelete}>
              <img src={deleteIcon} alt="Delete button icon" />
            </button>
          </animated.div>
        )}
        {isModalOpen && (
          <Modal
            isOpen={isModalOpen}
            onCancel={handleCloseModal}
            onConfirm={() => {
              setIsModalOpen(false);
              onDelete();
            }}
          />
        )}
      </div>
    </div>
  );
};
